/* eslint-disable */
export default {
  to: '撥給',
  enterNameOrNumber: '輸入姓名或號碼',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
